import { default as index } from './index.json'
import { default as Fundamentals } from './fundamentals.json'
import { default as Drive } from './drive.json'
import { default as Training } from './training.json'
import { default as PolicyManualWizard } from './policy-manual-wizard.json'
import { default as Surveys } from './surveys.json'
import { default as JobDescriptionGenerator } from './job-description-generator.json'
import { default as LiveHrAdvice } from './live-hr-advice.json'
import { default as TimeAttendance } from './time-attendance.json'
import { default as Complete } from './complete.json'

export default {
  ...index,
  Fundamentals,
  Drive,
  Training,
  PolicyManualWizard,
  Surveys,
  JobDescriptionGenerator,
  LiveHrAdvice,
  TimeAttendance,
  Complete
}



// WEBPACK FOOTER //
// ./src/translations/en/products/index.js